export const ADDED_QUESTION_TYPES = {
  INSTRUCTOR: 'Instructor-added Questions',
  INSTRUCTOR_UNIT: 'InstructorAddedQuestions',
  ACADEMIC_UNIT: 'AcademicUnitAddedQuestions'
} as const

export type AddedQuestionType = typeof ADDED_QUESTION_TYPES[keyof typeof ADDED_QUESTION_TYPES]
